import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

const spinnerVariants = cva(
	"animate-spin rounded-full border-(--color-muted) border-2 border-t-(--color-primary-500)",
	{
		variants: {
			size: {
				sm: "h-4 w-4",
				md: "h-8 w-8",
				lg: "h-12 w-12",
			},
		},
		defaultVariants: {
			size: "md",
		},
	},
);

export interface SpinnerProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof spinnerVariants> {}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
	({ className, size, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(spinnerVariants({ size }), className)}
			role="status"
			aria-label="Loading"
			{...props}
		/>
	),
);
Spinner.displayName = "Spinner";

export { Spinner };
